module.exports = __webpack_public_path__ + "media/investment_locations/Berlin-63de0e40.png";